(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kb-app-nav"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.kbSheets) return;
  var phone = window.matchMedia('(max-width: 749px)');

  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  function openSheet(dlg) {
    if (!dlg) return;
    if (dlg.open) dlg.close(); // a non-modal (desktop inline) dialog must close before showModal
    dlg.classList.remove('is-closing');
    dlg.style.transform = '';
    dlg.classList.add('is-opening');
    dlg.addEventListener('animationend', function () { dlg.classList.remove('is-opening'); }, { once: true });
    dlg.showModal();
    lock(true);
    dlg.dispatchEvent(new CustomEvent('kb:sheet-open'));
  }

  function closeSheet(dlg) {
    if (!dlg || !dlg.open || dlg.classList.contains('is-closing')) return;
    dlg.classList.add('is-closing');
    var done = function () {
      dlg.classList.remove('is-closing');
      dlg.style.transform = '';
      dlg.close();
      lock(false);
      dlg.dispatchEvent(new CustomEvent('kb:sheet-close'));
    };
    var anims = dlg.getAnimations ? dlg.getAnimations() : [];
    if (anims.length) Promise.all(anims.map(function (a) { return a.finished; })).then(done, done);
    else done();
  }

  // Drag down to dismiss. Listens on `area`; a drag only starts where canStart(e) is true.
  function draggable(sheet, area, canStart, onDismiss) {
    var startY = 0, lastY = 0, lastT = 0, v = 0, dragging = false;
    area.addEventListener('pointerdown', function (e) {
      if (!canStart(e) || e.target.closest('button, a, input, select, textarea')) return;
      dragging = true; startY = lastY = e.clientY; lastT = e.timeStamp; v = 0;
      sheet.classList.add('is-dragging');
      try { area.setPointerCapture(e.pointerId); } catch (err) {}
    });
    area.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dy = Math.max(0, e.clientY - startY);
      v = (e.clientY - lastY) / Math.max(1, e.timeStamp - lastT);
      lastY = e.clientY; lastT = e.timeStamp;
      sheet.style.transform = 'translateY(' + dy + 'px)';
    });
    function end(e) {
      if (!dragging) return;
      dragging = false;
      sheet.classList.remove('is-dragging');
      var dy = Math.max(0, e.clientY - startY);
      if (dy > 110 || (dy > 30 && v > 0.6)) { onDismiss(); return; }
      sheet.style.transition = 'transform 0.2s ease';
      sheet.style.transform = '';
      setTimeout(function () { sheet.style.transition = ''; }, 220);
    }
    area.addEventListener('pointerup', end);
    area.addEventListener('pointercancel', end);
  }

  function init(root) {
    root.querySelectorAll('dialog.kb-sheet').forEach(function (dlg) {
      if (dlg.dataset.kbSheetReady) return;
      dlg.dataset.kbSheetReady = '1';
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeSheet(dlg); });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) closeSheet(dlg); // tap on the backdrop
        if (e.target.closest('[data-kb-sheet-close]')) closeSheet(dlg);
      });
      var grab = dlg.querySelector('[data-kb-sheet-drag]');
      if (grab) draggable(dlg, grab, function () { return true; }, function () { closeSheet(dlg); });
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-kb-header-search]')) {
      // close the menu drawer first when the search pill inside it was tapped
      var drawer = e.target.closest('header-drawer');
      if (drawer && drawer.close) drawer.close();
      // open Horizon's search modal through its own (hidden on phones) trigger
      var trigger = document.querySelector('[on\\:click="#search-modal/showDialog"]');
      if (trigger) trigger.click(); else window.location.href = '/search';
      return;
    }
    var opener = e.target.closest('[data-kb-sheet]');
    if (opener) { e.preventDefault(); openSheet(document.getElementById(opener.dataset.kbSheet)); return; }
  });

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.kbSheets = { open: openSheet, close: closeSheet, init: init, phone: phone };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kb-bundle-upsell"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-kb-bundles]').forEach(function (wrap) {
  wrap.addEventListener('click', function (e) {
    var bundle = e.target.closest('[data-kb-bundle]');
    if (!bundle) return;
    if (!e.target.closest('button') && !e.target.closest('a')) {
      wrap.querySelectorAll('[data-kb-bundle]').forEach(function (b) { b.classList.toggle('is-selected', b === bundle); });
      return;
    }
    var toggle = e.target.closest('[data-kb-bundle-toggle]');
    if (toggle) {
      var exp = bundle.querySelector('[data-kb-bundle-expanded]');
      var label = bundle.querySelector('.kb-bundle__toggle-label');
      exp.hidden = !exp.hidden;
      toggle.setAttribute('aria-expanded', exp.hidden ? 'false' : 'true');
      if (label) label.textContent = exp.hidden ? (wrap.dataset.viewLabel || 'View Bundle') : (wrap.dataset.hideLabel || 'Hide Details');
      return;
    }
    var add = e.target.closest('[data-kb-bundle-add]');
    if (add) {
      var ids = (bundle.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      var original = add.innerHTML;
      add.disabled = true;
      add.textContent = wrap.dataset.addingLabel || 'Adding…';
      var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
      var done = function () { add.disabled = false; add.innerHTML = original; };
      if (window.kbCart) {
        window.kbCart.add(items).then(done, done);
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/cart';
      }).catch(done);
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kb-search-extras"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
  var chip = e.target.closest('[data-kb-search-term]');
  if (!chip) return;
  e.preventDefault();
  var dialog = chip.closest('dialog, .search-modal, predictive-search-component') || document;
  var input = dialog.querySelector('input[type="search"], .search-input');
  if (!input) { window.location.href = '/search?q=' + encodeURIComponent(chip.dataset.kbSearchTerm); return; }
  input.value = chip.dataset.kbSearchTerm;
  // Horizon's predictive search only runs for typing-style events (it checks event.inputType)
  var ev;
  try { ev = new InputEvent('input', { bubbles: true, inputType: 'insertText', data: input.value }); }
  catch (err) { ev = new Event('input', { bubbles: true }); }
  input.dispatchEvent(ev);
  input.focus();
});
  } catch(e) { console.error(e); }
})();

})();
